import React from 'react';
import { motion } from 'framer-motion';
import { HelpCircle } from 'lucide-react';
export function ObjectionsSection() {
  const objections = [{
    q: '¿Y si no me funciona?',
    a: 'Tienes 7 días de garantía total. Si no te convence, te devolvemos el 100% sin preguntas. El riesgo es literalmente cero.'
  }, {
    q: '¿Es muy básico para mí?',
    a: 'El sistema va desde cero absoluto hasta técnicas avanzadas de producción intensiva y emprendimiento. Hay contenido para todos los niveles.'
  }, {
    q: '¿Es muy avanzado? No sé nada de plantas.',
    a: 'Perfecto. Está diseñado para principiantes totales. Cada paso tiene explicación clara, sin tecnicismos. Si sabes regar, puedes seguir el sistema.'
  }, {
    q: '¿No será otro PDF genérico de internet?',
    a: 'No. Es un sistema estructurado paso a paso, con calendario regional, técnicas probadas y soluciones específicas. No es teoría suelta, es un método completo.'
  }, {
    q: 'No tengo espacio',
    a: 'El sistema está diseñado para adaptarse desde balcones de 1x1 hasta grandes patios. Te enseñamos a cultivar en vertical y en macetas.'
  }, {
    q: 'No tengo mucho tiempo',
    a: 'Una huerta bien planificada solo requiere 15 minutos al día. El sistema te enseña a simplificar tareas y optimizar tu tiempo.'
  }, {
    q: 'Ya intenté y me fue mal',
    a: 'Fallaste porque te faltaba el método. Con las instrucciones correctas sobre suelo, riego y luz, los resultados son predecibles. Este sistema elimina la improvisación.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Inmediatamente después del pago, recibes todo por email de forma automática. Son archivos PDF que puedes leer en cualquier dispositivo, para siempre.'
  }];
  return <section className="py-20 px-4 bg-zinc-950" data-id="element-135">
      <div className="max-w-5xl mx-auto" data-id="element-136">
        <div className="text-center mb-16" data-id="element-137">
          <h2 className="text-3xl font-bold text-white flex items-center justify-center gap-3" data-id="element-138">
            <HelpCircle className="w-8 h-8 text-zinc-500" data-id="element-139" />
            Preguntas que todos se hacen antes de comprar
          </h2>
          <p className="text-zinc-400 mt-3" data-id="element-140">
            Si tienes alguna de estas dudas, es normal. Aquí van las respuestas
            honestas.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-141">
          {objections.map((obj, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: index * 0.1
        }} viewport={{
          once: true
        }} className="p-6 bg-zinc-900 rounded-lg border-l-4 border-green-500 shadow-lg" data-id="element-142">
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-143">"{obj.q}"</h3>
              <p className="text-zinc-400" data-id="element-144">{obj.a}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}